import { clsx } from 'clsx';
export function cn(...inputs) {
    return clsx(inputs);
}
export function fmt(cents, symbol = '$') {
    return `${symbol}${(cents / 100).toFixed(2)}`;
}
export function fmtDate(date) {
    if (!date)
        return '—';
    return new Date(date).toLocaleDateString('en-AU', {
        day: '2-digit', month: 'short', year: 'numeric',
    });
}
export function fmtDateTime(date) {
    if (!date)
        return '—';
    return new Date(date).toLocaleString('en-AU', {
        day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
    });
}
export function fmtRelative(date) {
    if (!date)
        return '—';
    const d = new Date(date);
    const now = new Date();
    const diff = (now.getTime() - d.getTime()) / 1000;
    if (diff < 60)
        return 'Just now';
    if (diff < 3600)
        return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400)
        return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 604800)
        return `${Math.floor(diff / 86400)}d ago`;
    return fmtDate(date);
}
export function truncate(str, max) {
    return str.length > max ? str.slice(0, max) + '…' : str;
}
export function pctChange(old, curr) {
    if (old === 0)
        return { value: 0, up: true };
    const v = ((curr - old) / old) * 100;
    return { value: Math.abs(Math.round(v * 10) / 10), up: v >= 0 };
}
